export default function (path) {
  if (!path.endsWith("/")) return (path += "/")
  return path
}
